// src/pages/Services.tsx
import Header from '../components/Header';
import Services from '../components/Services';
import Footer from '../components/Footer';

const ServicesPage = () => {
  return (
    <div className="flex flex-col min-h-screen">
      <Header />
      <main>
        <Services />
      </main>
      <Footer />
    </div>
  );
};

export default ServicesPage;